var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_profile-2user",
    "data-name": "vuesax/bold/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.917,0a7.91,7.91,0,0,0-.2,15.817,1.345,1.345,0,0,1,.367,0H8.2A7.911,7.911,0,0,0,7.917,0Z",
    transform: "translate(7.083 3.333)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M20.2,2.325c-4.65-3.1-12.233-3.1-16.917,0A6.579,6.579,0,0,0,0,7.708a6.523,6.523,0,0,0,3.267,5.35,15.4,15.4,0,0,0,8.467,2.35,15.4,15.4,0,0,0,8.467-2.35,6.576,6.576,0,0,0,3.267-5.383A6.562,6.562,0,0,0,20.2,2.325Z",
    transform: "translate(3.267 21.258)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.8,5.472a5.965,5.965,0,0,1-5.217,6.45H4.5a.78.78,0,0,0-.283.033A5.98,5.98,0,0,1,0,10.572,7.627,7.627,0,0,0,2.5,4.239,7.735,7.735,0,0,0,1.217.606,5.984,5.984,0,0,1,9.8,5.472Z",
    transform: "translate(23.517 6.761)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M13.333,6.817a5.076,5.076,0,0,1-2.9,3.967,11.764,11.764,0,0,1-5.85,1.3A5.949,5.949,0,0,0,6.617,8.217,6.567,6.567,0,0,0,3.833,2.584,13.758,13.758,0,0,0,0,.484a13.026,13.026,0,0,1,11.167,1.95A5.064,5.064,0,0,1,13.333,6.817Z",
    transform: "translate(23.317 20.833)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H40V40H0Z",
    transform: "translate(40 40) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.5258400e26847870b9a593adbde6e3bb.svg";
export { ForwardRef as ReactComponent };